import { Component, Input } from '@angular/core';
import { AlertController, NavController } from 'ionic-angular';
import * as _ from 'lodash';

import { Location } from '../../models/location';
import { Data } from '../../providers/providers';
import { Thinning } from '../../providers/providers';
import { ThinningDataset } from '../../models/thinning-dataset';
import { ThinningMeasurement } from "../../models/thinning-measurement";
import { ThinningMeasurementDetailPage } from '../thinning-measurement-detail/thinning-measurement-detail';
import { ThinningMeasurementExportPage } from '../thinning-measurement-export/thinning-measurement-export';
import { ThinningMeasurementImportPage } from '../thinning-measurement-import/thinning-measurement-import';

@Component({
  selector: 'thinning-measurement-list',
  templateUrl: 'thinning-measurement-list.html'
})
export class ThinningMeasurementList {

  @Input() location: Location;
  @Input() dataset: ThinningDataset;
  measurements: ThinningMeasurement[];
  subscribedToMeasurements: boolean = false;

  constructor(public navCtrl: NavController,
              private alertCtrl: AlertController,
              public data: Data,
              public thinning: Thinning)
  {}

  ngOnChanges() {
    if (!this.subscribedToMeasurements) {
      var self = this;
      this.data.getThinningMeasurementsCollection(this.dataset).valueChanges().subscribe((ms) => {
        self.measurements = ms;
      });
      this.subscribedToMeasurements = true;
    }
  }

  addThinningMeasurement() {
    const meas = this.data.addNewThinningMeasurement(this.dataset);
    this.openMeasurement(meas);
  }

  openMeasurement(measurement: ThinningMeasurement) {
    this.navCtrl.push(ThinningMeasurementDetailPage, {
      dataset: this.dataset,
      location: this.location,
      measurement: measurement
    });
  }

  openMeasurementExport() {
    this.navCtrl.push(ThinningMeasurementExportPage, {
      dataset: this.dataset
    });
  }

  openMeasurementImport() {
    this.navCtrl.push(ThinningMeasurementImportPage, {
      location: this.location,
      dataset: this.dataset
    });
  }

  deleteMeasurement(meas: ThinningMeasurement) {
    let alert = this.alertCtrl.create({
      title: 'Confirm deletion',
      message: 'Permanently delete this Measurement?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Delete',
          handler: () => {
            this.data.removeThinningMeasurement(this.dataset, meas);
          }
        }
      ]
    });
    alert.present();
  }

  refreshAll() {
    _.each(this.measurements, (meas) => this.thinning.refreshThinningMeasurementSummary(meas));
    this.thinning.refreshThinningChartData('refresh');
    alert('Measurement summaries refreshed');
  }
}



// WEBPACK FOOTER //
// ./src/pages/thinning-measurement-list/thinning-measurement-list.ts